import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { EyeExamSection } from '../components/EyeExamSection/EyeExamSection.js';
import PrescriptionsListContainer from '../PrescriptionsList/PrescriptionsListContainer.js';

const PrescriptionPage = ()=>{
    const { getLabel  } = useIntl();
    const { isEyeExamEnabled  } = useFeatureToggles();
    const LABEL_PREFIX = 'account.prescription';
    return /*#__PURE__*/ React.createElement("div", {
        className: "prescription-page"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1",
        className: "prescription-page__title"
    }, getLabel(`${LABEL_PREFIX}.title`)), /*#__PURE__*/ React.createElement("div", {
        className: "prescription-page__list"
    }, /*#__PURE__*/ React.createElement(PrescriptionsListContainer, null)), isEyeExamEnabled && /*#__PURE__*/ React.createElement(EyeExamSection, {
        className: "prescription-page__eye-exam"
    }));
};
var PrescriptionPage$1 = PrescriptionPage;

export { PrescriptionPage$1 as default };
//# sourceMappingURL=PrescriptionPage.js.map
